/* global gapi */

// https://github.com/dxinteractive/react-google-auth/tree/master/src

import React from 'react'

const GoogleAuthExport = config => Component => {
  const { clientId, discoveryDocs, scope, signIn: SignIn } = config

  return class GoogleAuthHock extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        isSignedIn: false,
        initializing: false,
        error: null,
        signingIn: false,
        signingOut: false
      }
    }

    componentDidMount() {
      this.setState({
        initializing: true
      })

      gapi.auth2
        .init({
          clientId,
          discoveryDocs,
          scope
        })
        .then(oauth2 => {
          this.oauth2 = oauth2
          var { isSignedIn } = gapi.auth2.getAuthInstance()
          isSignedIn.listen(this.updateSignInStatus)
          this.updateSignInStatus(isSignedIn.get())

          this.setState({
            initializing: false
          })
        })
        .catch(error => {
          this.setState({
            error,
            initializing: false
          })
        })
    }

    handleSignInClick = () => {
      this.setState({
        signingIn: true
      })
      this.oauth2.grantOfflineAccess().then(this.signInCallback)
    }

    signInCallback = offlineAccessCode => {
      this.setState({
        offlineAccessCode
      })
    }

    handleSignOutClick = () => {
      this.setState({
        signingOut: true
      })
      gapi.auth2.getAuthInstance().signOut()
    }

    updateSignInStatus = isSignedIn => {
      this.setState({
        isSignedIn,
        signingIn: false,
        signingOut: false
      })
    }

    render() {
      const {
        initializing,
        isSignedIn,
        error,
        signingIn,
        signingOut,
        offlineAccessCode
      } = this.state

      if (!isSignedIn) {
        return (
          <SignIn
            {...this.props}
            onSignInClick={this.handleSignInClick}
            initializing={initializing}
            error={error}
            signingIn={signingIn} />
        )
      }

      return (
        <Component
          {...this.props}
          offlineAccessCode={offlineAccessCode}
          onSignOutClick={this.handleSignOutClick}
          signingOut={signingOut} />
      )
    }
  }
}

export default GoogleAuthExport



// WEBPACK FOOTER //
// ./src/schedule/gcal/googleOauth/GoogleAuthHock.js